import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {Product} from '../../generic/classes/product';
import {IntersectionState, LazyLoadService,} from '../../generic/component/lazyload/index';
import {ProductItemCommonComponent} from '../../generic/component/products/productitem.common.component';
import {BrowserService} from '../../generic/service/browser.service';
import {ProductService} from '../../generic/service/product.service';
import {ShoppingCartService} from '../../generic/service/shoppingcart.service';
import {TagManagerService} from '../../generic/service/tag.manager.service';
import {BuyOptionsComponent} from './item/buy.options.component';
import {ProductSizeComponent} from '../../generic/component/products/product.size.component';
import {ProductItemFavoriteComponent} from '../../generic/component/products/productitem.favorite.component';
import {RenderProductImageComponent} from '../../generic/component/products/render.product.image';
import {CustomDatePipe} from '../../generic/pipes/custom.date.pipe';
import {ProductMoreAvailableComponent} from '../../generic/component/products/product.more.available.component';
import {ProductQuantityUtils} from '../../generic/utils/product.quantity.utils';

@Component({
	selector: 'product-item-list',
	styleUrls: ['productitem.list.component.scss'],
	templateUrl: './productitem.list.component.html',
	standalone: true,
	imports: [
		RenderProductImageComponent,
		ProductItemFavoriteComponent,
		ProductSizeComponent,
		BuyOptionsComponent,
		CustomDatePipe,
		ProductMoreAvailableComponent,
	],
})
export class ProductItemListComponent extends ProductItemCommonComponent implements OnInit, AfterViewInit {
	private lazyLoadService = inject(LazyLoadService);
	private shoppingCartService = inject(ShoppingCartService);
	private tagManagerService = inject(TagManagerService);
	productService = inject(ProductService);

	@Input() product: Product;
	@Input() loggedIn: boolean;
	@Input() scrollToId: string;
	@Input() buttonsDisabled: boolean;
	showProduct: boolean = false;
	@Output() productMatchedFragmentEvent = new EventEmitter();
	@Output() viewProductDetailClickEvent = new EventEmitter();

	doLoad(state: IntersectionState) {
		this.showProduct = true;
	}

	triggerProductMatchedFragmentEvent(anchorValue: string) {
		this.productMatchedFragmentEvent.emit(anchorValue);
	}

	getImageAltTitle() {
		const productImageText = $localize`:@@product.image.alt.suffix:product image`;

		if (this.product.producer) {
			return this.productService.trimWhiteSpaceForProductDescriptions(
				`${this.product.totalDescription1} ${this.product.producer}`,
			);
		}

		return this.productService.trimWhiteSpaceForProductDescriptions(
			`${this.product.totalDescription1} ${productImageText}`,
		);
	}

	getScrollToId() {
		return this.scrollToId;
	}

	getProduct(): Product {
		return this.product;
	}

	getProductService() {
		return this.productService;
	}

	/**
	 * Redirects to the product detail page but sets a browser state before the actual routing.
	 */
	viewProductDetail() {
		const productDetailUrl = this.getProductDetailUrl();
		this.tagManagerService.trackProductViewClick(this.product);

		if (ProductItemCommonComponent.winRef.nativeWindow.openInNewTab) {
			return window.open(productDetailUrl);
		}

		this.productService.pushProductState(this.product);

		return this.viewProductDetailClickEvent.emit(productDetailUrl);
	}

	getProductDetailUrl() {
		return this.productService.getProductDetailUrl(this.product);
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	/**
	 * Take the quantity already ordered into account
	 *
	 * @returns {number}
	 */
	public getAvailableQuantity(): number {
		return ProductQuantityUtils.getAvailableBoxQuantity(
			this.product,
			this.shoppingCartService.activeShoppingCartLines,
		);
	}

	ngOnInit() {
		super.ngOnInit();

		if (BrowserService.isEdgeBrowser()) {
			this.showProduct = true;
		} else {
			this.lazyLoadService.isDevMode = false;
			this.lazyLoadService.loadAheadCount = 10;
		}
	}
}
